import { render, staticRenderFns } from "./SystemManagement.vue?vue&type=template&id=b0df00f8&scoped=true&"
import script from "./SystemManagement.vue?vue&type=script&lang=js&"
export * from "./SystemManagement.vue?vue&type=script&lang=js&"
import style0 from "./SystemManagement.vue?vue&type=style&index=0&id=b0df00f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0df00f8",
  null
  
)

export default component.exports